
export const environment = {
  production: false,
  // backEndUrl: 'https://ddb2wbzh-44344.inc1.devtunnels.ms/api/',
 //backEndUrl: 'https://kanbiosys-dev.dealernetwork.in/api/',
backEndUrl: 'https://kanbiosys-uat.dealernetwork.in/api/',
    // backEndUrl: 'https://kanbiosys.dealernetwork.in/api/',
      //backEndUrl: 'https://localhost:44344/api/',
  printerUrl: 'http://localhost:8888/'
};
